import { IcInfo } from '@assets/icons/32x32';
import { Button, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import CockpitDialog from '@components/cockpit/CockpitDialog';
import { usePatchReinitializePasswordMutation } from '@services/authent/user.api';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  id: number;
};

export default function ResetPassword({ id }: Readonly<Props>) {
  const [open, setOpen] = useState(false);
  const [reinitializePassword, { isLoading }] = usePatchReinitializePasswordMutation();

  return (
    <VStack gap={5} width="478px" alignSelf="center" paddingTop={8}>
      <Text textStyle="lg">
        <FormattedMessage id="components.usersManagement.users.password.title" />
      </Text>
      <HStack alignItems="start" width="100%" padding={5} gap={3} border="2px solid" borderColor="neutral.850">
        <Icon as={IcInfo} color="neutral.300" boxSize="32px" />
        <Text color="neutral.100" width="100%">
          <FormattedMessage id="components.usersManagement.users.password.description1" />
        </Text>
      </HStack>
      <Button size="md" onClick={() => setOpen(true)}>
        <FormattedMessage id="components.usersManagement.users.password.reset" />
      </Button>
      <CockpitDialog
        open={open}
        isLoading={isLoading}
        onConfirm={() =>
          reinitializePassword({ id })
            .unwrap()
            .then(() => setOpen(false))
        }
        onCancel={() => setOpen(false)}
      >
        <Text color="neutral.100" width="100%" whiteSpace="pre-line">
          <FormattedMessage id="components.usersManagement.users.password.modal.description1" />
        </Text>
        <Text color="neutral.100" width="100%" whiteSpace="pre-line">
          <FormattedMessage id="components.usersManagement.users.password.modal.description2" />
        </Text>
      </CockpitDialog>
    </VStack>
  );
}
